import { getPublicConfig } from '../@data-loaders/get-public-config';
import type { GlobalImport, Mh } from '../shared/interfaces';
import { once } from '../shared/once';

export const integrationLoaders: Record<GlobalImport, (mh: Mh) => Promise<HTMLScriptElement>> = {
    auth0: once(async (mh: Mh) => {
        const auth0Script = document.createElement(`script`);
        auth0Script.src = `${mh.scriptUrl}/assets/auth0-spa-js.production.2.1.js`;
        auth0Script.defer = true;
        return new Promise<HTMLScriptElement>((resolve) => {
            auth0Script.onload = () => {
                resolve(auth0Script);
            };
            document.body.appendChild(auth0Script);
        });
    }),
    recaptchaV3: once(async () => {
        const recaptchaScript = document.createElement(`script`);
        const publicConfig = await getPublicConfig();
        recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${publicConfig.integrations.recaptchaV3.siteKey}`;
        recaptchaScript.async = true;
        recaptchaScript.defer = true;
        document.body.appendChild(recaptchaScript);
        return new Promise<HTMLScriptElement>((resolve) => {
            recaptchaScript.onload = () => {
                resolve(recaptchaScript);
            };
            document.body.appendChild(recaptchaScript);
        });
    }),
    recurly: once(async (mh: Mh) => {
        const recurlyStyle = document.createElement(`link`);
        recurlyStyle.type = `text/css`;
        recurlyStyle.rel = `stylesheet`;
        recurlyStyle.href = `${mh.scriptUrl}/assets/recurly.css`;
        document.head.appendChild(recurlyStyle);

        const recurlyScript = document.createElement(`script`);
        recurlyScript.src = `${mh.scriptUrl}/assets/recurly.4.26.3.js`;
        document.body.appendChild(recurlyScript);

        return new Promise<HTMLScriptElement>((resolve) => {
            recurlyScript.onload = async () => {
                const publicConfig = await getPublicConfig();
                window.recurly.configure(publicConfig.integrations.recurly.publicKey);
                resolve(recurlyScript);
            };
            document.body.appendChild(recurlyScript);
        });
    }),
};
